// extracted by mini-css-extract-plugin
export default {"label":"jZhcXKVDQzT2FfhhmIYw"};